import { StackView, Text } from '@planningcenter/tapestry-react';
import React from 'react';
import { ChildNotice } from '../child_notice.js';
import { Person } from '../person_list_item.js';
import { useChatMembers } from './hooks/use_chat_members.js';
import { Section } from './section.js';

const LIMIT = 500;
const People = ({ channel }) => {
    const { chatMembers, loadingChatMembers } = useChatMembers(channel);
    const childPeople = chatMembers.filter((p) => p.child);
    const someChildPeople = childPeople.length > 0;
    const limitedChatMembers = chatMembers.slice(0, LIMIT);
    const hasMore = chatMembers.length > LIMIT;
    return (React.createElement(Section, { title: "People", loading: loadingChatMembers },
        React.createElement(StackView, { paddingBottom: 2, spacing: 1.5 },
            someChildPeople && React.createElement(ChildNotice, { childPeople: childPeople }),
            limitedChatMembers.map((person) => (React.createElement(Person, { key: person.id, person: person }))),
            hasMore && (React.createElement(Text, { color: "foregroundSecondary" },
                "and ",
                chatMembers.length - limitedChatMembers.length,
                " more...")))));
};

export { People };
//# sourceMappingURL=people.js.map
